import wixLocationFrontend from 'wix-location-frontend';
import { setRedirectingUrl } from 'public/redirectUrl';
import { session } from 'wix-storage-frontend';

$w.onReady(function () {
    let windowHref = wixLocationFrontend.url;
    const redirectingText = "#redirectingPage";
    const oldRef = "https://business.yellowpages.ca/";
    let newHref = "https://solutions.yp.ca/";
    let previousPageURL;
    previousPageURL = session.getItem("page");
    session.setItem("page", wixLocationFrontend.url);
    if (windowHref.includes(oldRef)) {
        console.log(windowHref, oldRef, newHref);
        windowHref = setRedirectingUrl(windowHref, oldRef, newHref);
        wixLocationFrontend.to(windowHref);
    }else if (previousPageURL != null && previousPageURL.includes('/scan-your-business')) {
        wixLocationFrontend.to(windowHref);
    }
});

